import api from '../../axios/api'
import moment from 'moment'
import axios from '../../axios/axios'
import {
  STARTLOADING,
  STOPLOADING,
  FETCHSCENARIO,
  FETCHDERICTORY,
  ERROR,
  HASREZULT,
  SAVE_USER_INFORMATION
} from '../types'

const arrCatalog = [
  'education', 'region', 'marital', 'employment_type', 'position_level', 'military_status_id', 'ent_segment'
]

export const checkPhone = (phone, clientToken) => dispatch => {
  dispatch({type: STARTLOADING})
  axios.defaults.headers.Authorization = 'Basic dXNlcjo2Y2dUNHE0anFlNEVLblNR'
  return api.checkPhone(phone, clientToken).then(res => {
    axios.defaults.headers.Authorization = res.data;
    const lastVerificationDate = moment().format('YYYY-MM-DD@HH:mm:ss')

    const url = new URL(window.location.href)
    const system = url.searchParams.get('system')

    api.checkCredit(phone, system).then(({data}) => {
      if(!data.message){
        dispatch({
          type: SAVE_USER_INFORMATION,
          clientData: {
            isWebBankClient: data.client,
            ...(data.clientData && {...data.clientData})
          }
        })
        api.fetchCatalog('/api/ccs/application/catalog', arrCatalog).then(catalog => {
          dispatch({type: FETCHDERICTORY, derictory: catalog.data})
        })
        .catch(error =>sendReportError({errorConfig: error}))
        api.fetchDatat('/api/ccs/script/1').then(scriptStatus => {
          dispatch({
            type: FETCHSCENARIO,
            scenario: {
              data: scriptStatus.data.scenario,
              countComponents: scriptStatus.data.countComponents,
              firstComponent: scriptStatus.data.firstComponent,
            },
            idOrder: data.applicationId,
            isClient: data.client,
            lastVerificationDate,
            phone
          })
          dispatch({type: STOPLOADING})
        })
        .catch(error => {
          console.log(error.response)
          sendReportError({errorConfig: error, applicationId: data.applicationId, phone})
          dispatch({type: ERROR, codeStatus: error.response ? error.response.status : 'failed'})
        })
      } else {
        dispatch({type: STOPLOADING})
        dispatch({type: HASREZULT, rezult: data.message})
      }
    })
    .catch(error => {
      sendReportError({errorConfig: error, phone})

      if(error && error.response && error.response.status === 406) {
        if(error.response.data && error.response.data.message) {
          dispatch({type: HASREZULT, rezult: error.response.data.message})
        }
      } else {
        dispatch({type: ERROR, codeStatus: error.response ? error.response.status : 'failed'})
      }
    })
  })
  .catch(error => {
    console.log(error)
    if(error.response && error.response.status === 400){
      dispatch({type: STOPLOADING})
    } else {
      sendReportError({errorConfig: error, phone})
      dispatch({type: ERROR, codeStatus: error.response ? error.response.status : 'failed'})
    }
  })
}

export const fetchOTP = phone => dispatch => {
  dispatch({type: STARTLOADING})
  axios.defaults.headers.Authorization = 'Basic dXNlcjo2Y2dUNHE0anFlNEVLblNR'
  return api.fetchOTP(phone).then(res => {
    dispatch({type: STOPLOADING})
    return res
  })
  .catch(error => {
    console.log(error, error.response)
    if(error.response && error.response.status === 400){
      dispatch({type: STOPLOADING})
      return 'blockedUser'
    } else {
      console.log('crash', error.response)
      sendReportError({errorConfig: error, phone})
      dispatch({type: ERROR, codeStatus: error.response ? error.response.status : 'failed'})
    }
  })
}


export const checkOTP = (phone, otp) => dispatch =>  {
  dispatch({type: STARTLOADING})
  axios.defaults.headers.Authorization = 'Basic dXNlcjo2Y2dUNHE0anFlNEVLblNR'
  return api.checkOTP(phone, otp).then(res => {
    axios.defaults.headers.Authorization = res.data;
    const lastVerificationDate = moment().format('YYYY-MM-DD@HH:mm:ss')

    const url = new URL(window.location.href)
    const system = url.searchParams.get('system')

    api.checkCredit(phone, system).then(res => {
      const {data} = res 
      if(!data.message){
        dispatch({type: SAVE_USER_INFORMATION,
          clientData: {
            isWebBankClient: data.client,
            ...(data.clientData && {...data.clientData})
          }
        })
        api.fetchCatalog('/api/ccs/application/catalog', arrCatalog).then(catalog => {
          dispatch({type: FETCHDERICTORY, derictory: catalog.data})
        })
        .catch(error =>sendReportError({errorConfig: error}))
        api.fetchDatat('/api/ccs/script/1').then(scriptStatus => {
          dispatch({
            type: FETCHSCENARIO,
            scenario: {
              data: scriptStatus.data.scenario,
              countComponents: scriptStatus.data.countComponents,
              firstComponent: scriptStatus.data.firstComponent,
            },
            idOrder: data.applicationId,
            isClient: data.client,
            lastVerificationDate,
            phone
          })
          dispatch({type: STOPLOADING})
        })
        .catch(error => {
          console.log(error.response)
          sendReportError({errorConfig: error, applicationId: data.applicationId, phone})
          dispatch({type: ERROR, codeStatus: error.response ? error.response.status : 'failed'})
        })
      } else {
        dispatch({type: STOPLOADING})
        dispatch({type: HASREZULT, rezult: data.message})
      }
    })
    .catch(error => {
      sendReportError({errorConfig: error, phone})

      if(error && error.response && error.response.status === 406) {
        if(error.response.data && error.response.data.message) {
          dispatch({type: HASREZULT, rezult: error.response.data.message})
        }
      } else {
        dispatch({type: ERROR, codeStatus: error.response ? error.response.status : 'failed'})
      }
    })
  })
  .catch(error => {
    console.log(error)
    if(error.response && error.response.status === 400){
      dispatch({type: STOPLOADING})
      return 'errorOTP'
    } else {
      sendReportError({errorConfig: error, phone})
      dispatch({type: ERROR, codeStatus: error.response ? error.response.status : 'failed'})
    }
  })
}

export const tempFetchCatalog = () => dispatch => {
  return api.fetchDatat('/api/ccs/application/catalog').then(catalog => {
    dispatch({type: FETCHDERICTORY, derictory: catalog.data})
  })
  .catch(error => console.log(error))
}

export const sendReportError = () => {
/*   const paramsReport = {
    appId,
    typeReq,
    urlApi,
    code,
    comment
  } */
  // const structureReport = renderStructurLogger(paramsReport)
  // console.log('Report: ', structureReport)
  // api.sendReport(structureReport)
}